import { I18n } from '@aws-amplify/core';
import { Form } from 'antd';

import { useApplicationContext } from '@/context/v1/Application/context';
import type { StepKey } from '@/hooks';
import { useGetAdditionalItemsOptions } from '@/hooks';

const RADIO_AND_INPUT_TYPE = 'radio_and_input';
const ONE_HAND_OPTION = 'one_hand';
const TWO_HANDS_OPTION = 'two_hands';
const ONE_HAND_WEIGHT_THRESHOLD = 3;
const TWO_HANDS_WEIGHT_THRESHOLD = 4.5;
const KIM_LHC_WEIGHT_WARNING =
	'For one-handed lifts above 3 kg, the KIM LHC is recommended. For two-handed lifts above 4.5 kg, the KIM LHC and NIOSH are recommended.';

const { useWatch } = Form;

export interface HeavyLiftingKimLhcWarning {
	show: boolean;
	message: string;
}

export function useHeavyLiftingKimLhcWarning(stepKey: StepKey, formFieldName: string[]): HeavyLiftingKimLhcWarning {
	const { organization, company } = useApplicationContext();

	const weightItem = stepKey.additional_items?.find(
		(item) => item.additional_item_type.type === RADIO_AND_INPUT_TYPE
	);

	const itemId = weightItem?.id ?? '';

	const optionsParams = {
		company_id: weightItem ? company?.id : undefined,
		organization_id: weightItem ? organization?.id : undefined,
		custom_report_step_key_id: weightItem ? stepKey.id : ''
	};

	const { data: options } = useGetAdditionalItemsOptions(optionsParams);

	const handlingOptionId = useWatch([...formFieldName, 'additional_items', itemId, 'additional_item_option_id_1']);
	const weightValue = useWatch([...formFieldName, 'additional_items', itemId, 'value_1']);

	const selectedHandling = options.find((option) => option.id === handlingOptionId)?.name;
	const weight = Number(weightValue);

	const isOneHandOverLimit = selectedHandling === ONE_HAND_OPTION && weight > ONE_HAND_WEIGHT_THRESHOLD;
	const isTwoHandsOverLimit = selectedHandling === TWO_HANDS_OPTION && weight > TWO_HANDS_WEIGHT_THRESHOLD;

	return {
		show: isOneHandOverLimit || isTwoHandsOverLimit,
		message: I18n.get(KIM_LHC_WEIGHT_WARNING)
	};
}
